import { formatDate } from '../util/dateUtils';

export default function ExpiryCell({ date }) {
  if (!date) return <td>-</td>;

  const today = new Date();
  const expiry = new Date(date);
  const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

  let className = '';
  if (expiry < today.setHours(0, 0, 0, 0)) className = 'bg-danger text-white';
  else if (diffDays <= 10) className = 'bg-warning text-dark';

  return <td className={className}>{formatDate(date)}</td>;
}
